export default "__VITE_ASSET__v2Qo62Gs__"